module.exports = "<div id=\"{{title | kebabCase}}\" class=sec><div class=sec-title><span class=txt>{{title}}</span></div><div class=sec-content><slot></slot></div></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Section.vue
 ** module id = 227
 ** module chunks = 0
 **/